// Demo Mode Configuration
// Set USE_MOCK_API to true to enable demo mode with dummy data
// Set USE_MOCK_API to false to use the real backend API

export const DEMO_CONFIG = {
  // Toggle this to switch between demo mode and real API
  USE_MOCK_API: true,

  // Mock API delay (ms) - simulates network latency
  MOCK_DELAY: 500,

  // Mock API success rate (0-1) - simulates occasional failures
  MOCK_SUCCESS_RATE: 0.98,

  // Enable console logs for mock API calls
  ENABLE_MOCK_LOGS: true,
};

export default DEMO_CONFIG;
